import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconStreaming: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconStreaming"><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H22V20H2ZM17.75 9.5C18.4404 9.5 19 8.94036 19 8.25C19 7.55964 18.4404 7 17.75 7C17.0596 7 16.5 7.55964 16.5 8.25C16.5 8.94036 17.0596 9.5 17.75 9.5ZM14.5 11C14.5 12.3807 13.3807 13.5 12 13.5C10.6193 13.5 9.5 12.3807 9.5 11C9.5 9.61929 10.6193 8.5 12 8.5C13.3807 8.5 14.5 9.61929 14.5 11ZM7.5 18.5C7.5 17.3333 9 15 12 15C15 15 16.5 17.3333 16.5 18.5H7.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconStreaming;
